import React, { useState, useEffect, useContext } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { ThreeDots } from 'react-bootstrap-icons';
import DropMore from './DropMore';
import {SidebarStateContext} from './Dashboard';  
import '../../App.css';
import axios from "axios";

export default function Overview() {
    const { isSidebarOpen } = useContext(SidebarStateContext);
    //console.warn("recieved sidebar status: " + String(isSidebarOpen));

    const navigate = useNavigate();
    const [isMoreOpen, doMore] = useState(false);
    const [userLoggedRole, setUserLoggedRole] = useState('');
    const toggleMore = () => { doMore((prev) => !prev); };

    useEffect(() => {
        navigate('main/'); // show the overview first

        axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
        .then((res) => {
          if (res.data.status === 1) {
            // console.log("User session is alive:", res.data);
            // console.log("User Full Name:", res.data.fullname);
            // console.log("User Role:", res.data.role);
            setUserLoggedRole(res.data.role);
            
          } else {
            console.warn("Session error:", res.data.message);
          }

        })
        .catch((err) => {
          //console.error("ERROR: Your session cannot be found!", err);
  
        });

        // if (!userLoggedRole) {
        //     navigate('/start/', { replace: true });
        // }

        // TODO axios get with user id, if logged user status=deactivated, axios post to logout.php
        
    }, []);

    let topbarItem = [];
    
    const totalTopbarEmployee = [
        { path: 'main/', name: 'Overview' },
        { path: 'transactions/', name: 'Transactions' },
        // { path: 'documents/', name: 'Documents' },
        // { path: 'reports/', name: 'Reports' },
    ];

    const totalTopbarAdmin = [
        ...totalTopbarEmployee,
        // { path: 'tasks/', name: 'Tasks' },
        // { path: 'manage/requests', name: 'Debug' }, // FOR DEBUGGING FLOATING BUTTON ONLY
        // { path: 'team/', name: 'Team' },
    ];

    // Only call toUpperCase if userLoggedRole is not null or empty
    if (userLoggedRole && userLoggedRole.toUpperCase) {
        switch (userLoggedRole.toUpperCase()) {
            case 'STAFF':
                topbarItem = totalTopbarEmployee;
                break;
            case 'ADMIN':
                topbarItem = totalTopbarAdmin;
                break;
            default:
                topbarItem = totalTopbarEmployee;
        }
    }
    
    return (
        <div className='content_area'>
            <h2 className='title header'>Dashboard</h2>

            <section className='topbar'>
                {topbarItem.map((item, index) => (
                    <NavLink 
                        to={item.path} 
                        key={index} 
                        className={'item_topbar'} 
                        title={item.name} 
                        activeClassName='active'
                    >
                        <div>{item.name}</div>
                    </NavLink>
                ))}

                {/* Show logged-in user's role */}
                <div className='txt role' title={`You are: ${userLoggedRole}`}>
                    {userLoggedRole ? userLoggedRole : 'Role not found'}
                </div>

                {/* Three dots icon for More dropdown */}
                <ThreeDots 
                    className='clickable dotsmore' 
                    title='More' 
                    onClick={toggleMore}
                />

                {/* Dropdown container based on the isMoreOpen state */}
                <DropMore 
                    className={`container-more ${isMoreOpen ? '' : 'minimized'}`} 
                />
            </section>

            {/* Outlet for child routes */}
            <Outlet />
        </div>
    );
}
